import { defineMessages } from 'react-intl';

/** The words of the Page tab (design a6, e4). */
export const pageMessages = defineMessages({
  address: { id: 'app.sml.smartlinks.editor.page.address', defaultMessage: 'Address' },
  domain: { id: 'app.sml.smartlinks.editor.page.domain', defaultMessage: 'Domain' },
  domainHelp: {
    id: 'app.sml.smartlinks.editor.page.domain_help',
    defaultMessage: 'Also fym.fm, music.ht and music.mq. All four open the same page.',
  },
  slug: { id: 'app.sml.smartlinks.editor.page.slug', defaultMessage: 'End of the address' },
  slugFree: { id: 'app.sml.smartlinks.editor.page.slug_free', defaultMessage: 'Free' },
  slugChecking: { id: 'app.sml.smartlinks.editor.page.slug_checking', defaultMessage: 'Checking' },
  slugTaken: { id: 'app.sml.smartlinks.editor.page.slug_taken', defaultMessage: 'Taken' },
  slugTakenHelp: {
    id: 'app.sml.smartlinks.editor.page.slug_taken_help',
    defaultMessage: 'Another page uses this address.',
  },
  slugIllegal: {
    id: 'app.sml.smartlinks.editor.page.slug_illegal',
    defaultMessage: 'Use letters, numbers and dashes only.',
  },
  slugUse: { id: 'app.sml.smartlinks.editor.page.slug_use', defaultMessage: 'Use {slug}' },
  slugLiveWarning: {
    id: 'app.sml.smartlinks.editor.page.slug_live_warning',
    defaultMessage: 'The page is live. Your old link keeps working and sends fans to the new address.',
  },
  bioAddressHelp: {
    id: 'app.sml.smartlinks.editor.page.bio_address_help',
    defaultMessage: 'Your Bio Link is your account address. Change it in Settings → Artist.',
  },
  openArtistSettings: {
    id: 'app.sml.smartlinks.editor.page.open_artist_settings',
    defaultMessage: 'Open Settings → Artist',
  },
  name: { id: 'app.sml.smartlinks.editor.page.name', defaultMessage: 'Name' },
  nameHelp: {
    id: 'app.sml.smartlinks.editor.page.name_help',
    defaultMessage: 'Shows in the browser tab, in your list of pages and in search results.',
  },
  nameEmpty: { id: 'app.sml.smartlinks.editor.page.name_empty', defaultMessage: 'Give the page a name. Not saved.' },
  saved: { id: 'app.sml.smartlinks.editor.page.saved', defaultMessage: 'Saved · not live yet' },
  saving: { id: 'app.sml.smartlinks.editor.page.saving', defaultMessage: 'Saving' },
  saveFailed: { id: 'app.sml.smartlinks.editor.page.save_failed', defaultMessage: 'Not saved. Try again.' },
  share: { id: 'app.sml.smartlinks.editor.page.share', defaultMessage: 'Share picture' },
  shareHelp: {
    id: 'app.sml.smartlinks.editor.page.share_help',
    defaultMessage: 'From the release kit (link preview). Remake it in the Studio.',
  },
  openStudio: { id: 'app.sml.smartlinks.editor.page.open_studio', defaultMessage: 'Open the Studio' },
  status: { id: 'app.sml.smartlinks.editor.page.status', defaultMessage: 'Status' },
  liveSince: { id: 'app.sml.smartlinks.editor.page.live_since', defaultMessage: 'Live since {date}' },
  notLive: { id: 'app.sml.smartlinks.editor.page.not_live', defaultMessage: 'Not live yet' },
  notLiveHelp: {
    id: 'app.sml.smartlinks.editor.page.not_live_help',
    defaultMessage: 'Fans see the page after you publish it.',
  },
  pending: {
    id: 'app.sml.smartlinks.editor.page.pending',
    defaultMessage: '{count, plural, one {# change is} other {# changes are}} not live yet.',
  },
  pendingNoCount: {
    id: 'app.sml.smartlinks.editor.page.pending_no_count',
    defaultMessage: 'Some changes are not live yet.',
  },
  upToDate: { id: 'app.sml.smartlinks.editor.page.up_to_date', defaultMessage: 'Fans see every change.' },
  offline: { id: 'app.sml.smartlinks.editor.page.offline', defaultMessage: 'Take the page offline' },
  offlineHelp: {
    id: 'app.sml.smartlinks.editor.page.offline_help',
    defaultMessage: 'Fans see "This page is not available". You keep the blocks and the stats.',
  },
  unpublish: { id: 'app.sml.smartlinks.editor.page.unpublish', defaultMessage: 'Unpublish' },
  delete: { id: 'app.sml.smartlinks.editor.page.delete', defaultMessage: 'Delete the page' },
  deleteHelp: { id: 'app.sml.smartlinks.editor.page.delete_help', defaultMessage: 'The stats go too.' },
  deleteButton: { id: 'app.sml.smartlinks.editor.page.delete_button', defaultMessage: 'Delete' },
  // Bio Link settings (e4).
  newSongs: { id: 'app.sml.smartlinks.editor.page.new_songs', defaultMessage: 'New songs' },
  autoAdd: { id: 'app.sml.smartlinks.editor.page.auto_add', defaultMessage: 'Add new songs automatically' },
  autoAddHelp: {
    id: 'app.sml.smartlinks.editor.page.auto_add_help',
    defaultMessage: 'When you add a song to your Catalog, its Catalog links go on this page.',
  },
  where: { id: 'app.sml.smartlinks.editor.page.where', defaultMessage: 'Where' },
  whereProfile: { id: 'app.sml.smartlinks.editor.page.where_profile', defaultMessage: 'Under your profile' },
  whereEnd: { id: 'app.sml.smartlinks.editor.page.where_end', defaultMessage: 'At the end' },
  olderSongs: { id: 'app.sml.smartlinks.editor.page.older_songs', defaultMessage: 'Older songs' },
  keepOne: { id: 'app.sml.smartlinks.editor.page.keep_one', defaultMessage: 'Keep only the newest' },
  keepThree: { id: 'app.sml.smartlinks.editor.page.keep_three', defaultMessage: 'Keep the 3 newest' },
  keepFive: { id: 'app.sml.smartlinks.editor.page.keep_five', defaultMessage: 'Keep the 5 newest' },
  keepAll: { id: 'app.sml.smartlinks.editor.page.keep_all', defaultMessage: 'Keep all' },
  keepHelp: {
    id: 'app.sml.smartlinks.editor.page.keep_help',
    defaultMessage: 'A newer song hides the oldest block. You can show it again in Blocks.',
  },
  keepAllHelp: {
    id: 'app.sml.smartlinks.editor.page.keep_all_help',
    defaultMessage: 'Every song stays on the page.',
  },
  newSongsNote: {
    id: 'app.sml.smartlinks.editor.page.new_songs_note',
    defaultMessage:
      'Songs that are in your Catalog now do not change. Add one by hand with Add block → Catalog links of a song.',
  },
});
